module.exports = __webpack_public_path__ + "img/room_basketball_bg.bd66e2b5.png";